import Button from '@hotmart/space-lib/dist/components/button'
import i18n from 'src/i18n'
import { ButtonActionsProps } from './buttonActions.types'
import { Wrapper } from './buttonActions.styles'

const ButtonActions = ({
  disabledActions,
  disabledSubmit,
  onReset,
  onSubmit
}: ButtonActionsProps) => {
  return (
    <Wrapper className="_d-flex">
      <Button
        variation="tertiary"
        disabled={disabledActions}
        loading={disabledActions}
        onClick={onReset}
      >
        {i18n.t('comments.button_cancel')}
      </Button>

      <Button
        variation="primary"
        disabled={disabledSubmit || disabledActions}
        loading={disabledActions}
        onClick={onSubmit}
      >
        {i18n.t('comments.button_publish')}
      </Button>
    </Wrapper>
  )
}

export default ButtonActions
